import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { InvoiceManagerComponent } from './invoice-manager.component';
import { ConsumptionsModule } from '../consumptions/consumptions.module';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ISDateTimePickerModule } from '../is-date-time-picker/is-date-time-picker.module';
import { InvoiceFormComponent } from './invoice-form/invoice-form.component';
import { ISFileUploadModule } from '../is-files-upload/is-files-upload.module';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SharedModule } from '../shared.module';

const materialModules = [
    MatIconModule,
    MatSelectModule,
    MatAutocompleteModule,
    MatTooltipModule
];

const isModules = [
    ISDateTimePickerModule,
    ISFileUploadModule
];


@NgModule({
    declarations: [InvoiceManagerComponent, InvoiceFormComponent],
    imports: [
        CommonModule,
        ConsumptionsModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        ...isModules,
        ...materialModules    
    ],
    exports: [InvoiceManagerComponent],
    providers: [],
})
export class InvoiceManagerModule {}